import styled from 'theme';

export const GeneralTitle = styled.div`
  font-size: ${p => p.theme.variables.fonts.size.base};
  line-height: 1.5;
  color: ${p => p.theme.variables.customColors.textColor};
  margin-top: -0.125rem;
`;

export const GeneralRedirectUrl = styled.div`
  &:not(:last-child) {
    margin-bottom: 0.25rem;
  }
`;

export const LogoStatusWrapper = styled.div`
  .application-general__verified-icon {
    width: 2rem;
    height: 2rem;
    margin-top: -0.3rem;
  }
  .application-general__error-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.2rem;
  }
  .application-general__logo-status {
    font-size: ${props => props.theme.variables.fonts.size.base};
    color: ${props => props.theme.variables.customColors.lightNavy};
    display: flex;
    align-items: flex-start;
  }

  .application-general__logo-error-status {
    font-size: ${props => props.theme.variables.fonts.size.base};
    color: ${props => props.theme.variables.customColors.linkColor};
    margin-left: 0.2rem;
    display: flex;
    align-items: flex-start;
  }
`;
